// extracted by mini-css-extract-plugin
module.exports = {"input":"Search_input__tqXZG","button":"Search_button__12Lt1","wrapper":"Search_wrapper__TT7ri"};